module.exports = __webpack_public_path__ + "img/mailbox_multi.fe57fa9c.svg";